import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { Badge, DataTable, PageHeader } from '@/components/ui';
import { api } from '@/lib/api';
export function LeaveBalancesPage() {
    const bals = useQuery({
        queryKey: ['leave-balances'],
        queryFn: async () => (await api.get('/hrms/leave-balances/')).data,
    });
    return (_jsxs("div", { className: "space-y-4", children: [_jsx(PageHeader, { title: "Leave balances", description: "Entitlement, taken, and remaining days per employee per kind." }), _jsx(DataTable, { rows: bals.data, rowKey: (r) => r.id, loading: bals.isLoading, columns: [
                    { key: 'emp', header: 'Employee', render: (b) => b.employee_name },
                    { key: 'kind', header: 'Kind', render: (b) => _jsx(Badge, { tone: "info", children: b.kind }) },
                    { key: 'year', header: 'Year', render: (b) => b.year },
                    { key: 'ent', header: 'Entitled', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono", children: b.entitled_days }) },
                    { key: 'taken', header: 'Taken', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono", children: b.taken_days }) },
                    { key: 'co', header: 'Carried over', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono text-muted-foreground", children: b.carried_over_days }) },
                    { key: 'rem', header: 'Remaining', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono font-semibold", children: b.remaining_days }) },
                ] })] }));
}
